import { render, staticRenderFns } from "./IconAllInbox.vue?vue&type=template&id=1a1a4d74"
import script from "./IconAllInbox.vue?vue&type=script&lang=js"
export * from "./IconAllInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports